module.exports = __webpack_public_path__ + "img/AramKakayFalah-rudaw.17652057.jpg";